import { ColDef, ValueGetterParams } from 'ag-grid-community';
import { ArticleSummary } from '../../../../../shared/types';
import { sortArray } from '../../../../../utils/sorting.utils';

const userGuideOrderingColumnDefs: ColDef<ArticleSummary>[] = [
    {
        colId: 'user-guide-order-drag-col',
        headerName: '',
        width: 40,
        rowDrag: true,
        cellRenderer: 'agRowDragCellRenderer',
        suppressHeaderMenuButton: true,
        sortable: false,
        menuTabs: [],
    },
    {
        colId: 'user-guide-order-title-col',
        headerName: 'Title',
        field: 'title',
        width: 180,
        menuTabs: [],
    },
    {
        colId: 'user-guide-order-scopes-col',
        headerName: 'Scopes',
        valueGetter: (params: ValueGetterParams<ArticleSummary>) =>
            sortArray(params.data?.userGuideScopes ?? []).join(', '),
        flex: 1,
        menuTabs: [],
        autoHeight: true,
        wrapText: true,
    },
];

export default userGuideOrderingColumnDefs;
